var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 7.60003C8.88366 7.60003 9.60001 6.88368 9.60001 6.00002C9.60001 5.11637 8.88366 4.40002 8.00001 4.40002C7.11635 4.40002 6.40001 5.11637 6.40001 6.00002C6.40001 6.88368 7.11635 7.60003 8.00001 7.60003Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.366211 6.00006C1.38561 2.75435 4.41785 0.400024 7.99998 0.400024C11.5821 0.400024 14.6143 2.75433 15.6337 6C14.6143 9.2457 11.5821 11.6 7.99996 11.6C4.41786 11.6 1.38563 9.24573 0.366211 6.00006ZM11.2 6.00002C11.2 7.76734 9.76732 9.20003 8.00001 9.20003C6.2327 9.20003 4.80001 7.76734 4.80001 6.00002C4.80001 4.23271 6.2327 2.80002 8.00001 2.80002C9.76732 2.80002 11.2 4.23271 11.2 6.00002Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes);
export default __webpack_public_path__ + "static/media/eyes.6361f6c8d0c4a06fb00eba2a1ccc3259.svg";
export { ForwardRef as ReactComponent };